import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import CustomChip from '../../../../../../shared/components/CustomChip'
import { IBrand, ILine, VIP } from '../../../../models/user'
import { isCommercialOrClientOrTrainer } from '../../../../utils/RolesHelper'

interface VipStatusChipProps {
  data: IBrand | ILine
}

enum VIP_TYPE {
  temporary = 0,
  permanent = 1
}

export function VipStatusChip({ data }: VipStatusChipProps) {
  const { t } = useTranslation(['global'])

  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const { vipStatus, vipType } = data

  let color: string = 'default'
  let label: string = t('admin.people.unassigned')

  if ((vipType === VIP_TYPE.permanent && vipStatus === VIP.Active) || !isCommercialOrClientOrTrainer(userProfileSelected.role_id)) {
    color = 'primary'
    label = t('admin.people.permanent')
  } else if (!vipStatus) {
    color = 'default'
    label = t('admin.people.unassigned')
  } else if (vipStatus === VIP.Pending) {
    color = 'secondary'
    label = t('admin.people.pending')
  } else if (vipStatus === VIP.Denied) {
    color = 'secondary'
    label = t('admin.people.denied')
  } else if (vipType === VIP_TYPE.temporary && vipStatus === VIP.Active) {
    color = 'secondary'
    label = t('admin.people.temporary')
  }

  return <CustomChip type={2} color={color} label={label} />
}
